export class TakeOnFleetViewModel {
  operatorId: string;
  aircraftId: number;
  additionalInstructions: string;
}